import React, {PureComponent} from 'react'
import {inject, observer} from 'mobx-react'
import Store from 'Store'
import {t} from 'helpers/i18n'
import {Button} from 'elements'

interface Props {
  store?: Store
}

@inject('store')
@observer
class UserLogout extends PureComponent<Props, object> {
  render() {
    return (
      <Button onClick={this.props.store!.users.logout} {...this.props}>
        {t('logOut')}
      </Button>
    )
  }
}

export default UserLogout



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/Users/containers/UserLogout.tsx